import { Component } from '@angular/core';
import { transition, trigger, useAnimation } from '@angular/animations';
import { fadeIn } from 'ng-animate';
import { select, Store } from '@ngrx/store';
import { IRootState } from '@mnz-core/modules/store/models/root-state';
import { TranslateService } from '@ngx-translate/core';
import * as routerSelectors from '@mnz-core/modules/store/selectors/router.selectors';
import { map, switchMap } from 'rxjs/operators';
import { Params } from '@angular/router';
import { AccountType } from '@mnz-core/models/_enums';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import * as authSelectors from '@mnz-modules/login/store/selectors/auth.selectors';
import * as authActions from '@mnz-modules/login/store/actions/auth.actions';

@Component({
  templateUrl: 'logout.page.html',
  animations: [trigger('fadeIn', [transition('* => *', useAnimation(fadeIn, { params: { timing: 0.5 } }))])],
})
export class LogoutPage {
  constructor(
    private readonly _store$: Store<IRootState>,
    private readonly _translate: TranslateService,
    private readonly _breakpoint: BreakpointObserver
  ) {}

  readonly isHandsetPortrait$ = this._breakpoint
    .observe(Breakpoints.HandsetPortrait)
    .pipe(map(({ matches }) => matches));

  loading$ = this._store$.pipe(select(authSelectors.getLoading));

  readonly accountTypeTranslation$ = this._store$.pipe(
    select(routerSelectors.getParams),
    map<Params, AccountType>(({ account }) => account),
    switchMap((account) => {
      return this._translate.get(account === AccountType.CARD_HOLDER ? 'CARD_HOLDER' : 'CONTACT_PERSON');
    }),
    map((translation) => String(translation).toLowerCase())
  );

  logout() {
    this._store$.dispatch(authActions.logout());
  }
}
